/** @format */

import React, { useEffect } from "react";
import useSettings from "stores/settings";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";

import { PageTokenCheck } from "function/PageTokenCheck";
import SEO from "components/SEO";

const Payment = observer(({ headUrl, headTitle, headDesc }) => {
  const settings = useSettings();
  const router = useRouter();

  /* 로그인 체크 : url 이동 */
  useEffect(() => {
    PageTokenCheck(settings, router);
  }, []);

  return (
    <div className="w-full">
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <div className="flex flex-col page-content w-full pt-12 pb-36 items-center justify-center">
        <h3 className="font-bold mb-2">크레딧 충전/현황</h3>
        <p className="text-gray mb-4">크레딧 충전 및 현황 페이지 준비중입니다.</p>
      </div>
    </div>
  );
});

Payment.getInitialProps = async () => {
  let headTitle = "AISO PAYMENT";
  let headDesc = "크레딧을 충전하여 앱을 사용하세요.";
  const headUrl = `https://aiso.ai/user/payment`;

  return { headUrl, headTitle, headDesc };
};
export default Payment;
